/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/**
 * Este arquivo carrega os polyfills necessarios antes da aplicacao.
 *
 * O `zone.js` foi removido: a aplicacao usa change detection dirigida por Signals
 * (provideZonelessChangeDetection no AppModule), entao nao ha mais necessidade de
 * monkey-patch das APIs assincronas do browser para detectar mudancas.
 */
